import { Component, Suspense, type ReactNode } from 'react';
import { useI18n } from './i18n';

class RouteErrorBoundary extends Component<{ children: ReactNode; fallback: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  override render() { return this.state.failed ? this.props.fallback : this.props.children; }
}

export function RouteBoundary({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  return <RouteErrorBoundary fallback={<div className="error" role="alert">
    <p>{t('route.loadError')}</p>
    <button className="secondary" onClick={() => location.reload()}>{t('provider.reload')}</button>
  </div>}>
    <Suspense fallback={<p role="status">{t('common.loadingStation')}</p>}>{children}</Suspense>
  </RouteErrorBoundary>;
}
